import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Ordrer',
  buttons: {
    actions: 'Handlinger',
    [action_create_dummy_order]: 'Opret testordre',
    [action_launch_orders_portal_app]: 'Start ordreportal',
    show_order_details: 'Vis ordredetaljer',
    track_order: 'Spor ordre',
    update_dropoff_time: 'Opdater afleveringstidspunkt',
    download_receipt: 'Download kvittering',
    open_payment_page: 'Åbn betalingsside',
  },
  form: {
    customer_details: {
      placeholder: 'Indtast kundenavn eller telefonnummer',
    },
    amount_min: {
      placeholder: 'Min. beløb',
    },
    amount_max: {
      placeholder: 'Maks. beløb',
    },
    utm_source: {
      placeholder: 'Indtast utm-kilde',
    },
    utm_medium: {
      placeholder: 'Indtast utm-medium',
    },
    utm_campaign: {
      placeholder: 'Indtast utm-kampagne',
    },
    utm_advertisement_id: {
      placeholder: 'Indtast utm-annonce-id',
    },
  },
  labels: {
    no_orders: 'Ingen ordrer endnu',
    total_orders: 'Ordrer i alt',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Afhentning',
    [ORDER_METHODS.delivery]: 'Levering',
    [ORDER_METHODS.room_service]: {
      [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Roomservice',
      [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Bordservice',
    },
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'Afventer',
    [ORDER_PAYMENT_STATUSES.paid]: 'Betalt',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Delvist refunderet',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Refunderet',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'Afventer godkendelse',
      [FULFILLMENT_STATUSES.reviewed]: 'Afventer godkendelse',
      [FULFILLMENT_STATUSES.accepted]: 'I gang',
      [FULFILLMENT_STATUSES.preparing]: 'I gang',
      [FULFILLMENT_STATUSES.ready]: 'I gang',
      [FULFILLMENT_STATUSES.on_delivery]: 'I gang',
      [FULFILLMENT_STATUSES.picked]: 'Gennemført',
      [FULFILLMENT_STATUSES.rejected]: 'Afvist',
      null: 'Ukendt',
      undefined: 'Ukendt',
    },
  },
  tags: {
    dummy: 'TEST',
    pickup: 'Afhentning',
    internal_delivery: 'Intern levering',
    external_delivery: 'Ekstern levering',
    room_service: 'Roomservice',
    table_service: 'Bordservice',
    scheduled: 'Planlagt',
    reward: 'Belønning',
    mobile: 'Mobil',
    invoice: 'Faktura',
    cash: 'Kontant',
    rejected_automatically: 'Automatisk afvist',
    rejected_manually: 'Manuelt afvist',
    call_center: 'Callcenter',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    tags: 'Tags',
    order_placed: 'Ordre afgivet',
    ready_at: 'Ordre klar',
    customer: 'Kunde',
    items: 'Varer',
    method: 'Metode',
    payment_status: 'Betalingsstatus',
    fulfillment_status: 'Status',
    total: 'I alt',
    utm_source: 'UTM-kilde',
    utm_medium: 'UTM-medium',
    utm_campaign: 'UTM-kampagne',
    utm_advertisement_id: 'UTM-annonce-id',
  },
  metrics: {
    total_orders: 'Ordrer i alt',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_create_dummy_order: 'Testordren kunne ikke oprettes',
    dummy_order_created: 'Testordren er oprettet',
    failed_to_launch_orders_portal_app: 'Ordreportalen kunne ikke startes',
    failed_to_download_receipt: 'Kvitteringen kunne ikke downloades',
  },
};
